import { gql } from '@apollo/client';

export const CREATE_ADS_WITH_CREATIVES_CREATIVE_ENTITY_FIELDS = gql`
  fragment CreateAdsWithCreativesCreativeEntityFields on CreateAdsWithCreativesCreativeEntity {
    ... on VideoCreativeV5 {
      id
      name
      type
      creativeLibraryId
    }
    ... on VASTVideoCreativeV5 {
      id
      name
      type
      creativeLibraryId
    }
    ... on SlateCreativeV5 {
      id
      name
      type
      creativeLibraryId
    }
    ... on CreateAdsWithCreativesFailedCreativeEntity {
      failedType: type
      name
      failedCreativeLibraryId: creativeLibraryId
    }
  }
`;
